rdefine('app/products/properties/Floorplan',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'floor-plan-field',
        initialize:function(options) {
            this.cform = options.cform;
            this.field = "property_"+this.model.get("id");
            this.$el.html('<input type="hidden" name="property" value=""/>');
            this.$el.find("input").val(JSON.stringify(this.cform.get(this.field)));
            this.fi = new FloorPlanField(this.$el[0],function(val) {
                this.cform.set(this.field,val);
                this.cform.trigger("change:"+this.field);
            }.bind(this));
            this.cform.on("change:"+this.field,function(){
                this.fi.updateFrom(this.cform.get(this.field));
            }.bind(this));
        }
    });
});